import { memo } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0AvatarIcon } from '@factorialco/f0-react'
import { ArrowCycle, CheckCircle, Sparkles, ThumbsUp } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { CONNECTING_LINE_POSITION, STATUS_COLORS } from './types'
import type { ItemStatus } from './types'
import styles from './styles.module.css'

// Icon components defined at module level to avoid recreation on every render
const CompletedIcon = memo(() => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 5.33301C21.891 5.33301 26.667 10.109 26.667 16C26.667 21.891 21.891 26.667 16 26.667C10.109 26.667 5.33301 21.891 5.33301 16C5.33301 10.109 10.109 5.33301 16 5.33301ZM21.7227 11.4805C21.4355 11.2653 21.0288 11.3232 20.8135 11.6104L15.2627 19.0098L11.793 15.54C11.5391 15.2864 11.1268 15.2863 10.873 15.54C10.6194 15.7938 10.6194 16.2062 10.873 16.46L14.873 20.46C15.0062 20.5931 15.1911 20.6616 15.3789 20.6484C15.5668 20.6351 15.7395 20.5403 15.8525 20.3896L21.8525 12.3896C22.0679 12.1025 22.0098 11.6959 21.7227 11.4805Z"
      fill={STATUS_COLORS.completed}
    />
  </svg>
))
CompletedIcon.displayName = 'CompletedIcon'

const RejectedIcon = memo(() => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 5.33301C21.891 5.33301 26.667 10.109 26.667 16C26.667 21.891 21.891 26.667 16 26.667C10.109 26.667 5.33301 21.891 5.33301 16C5.33301 10.109 10.109 5.33301 16 5.33301ZM21.7227 11.4805C21.4355 11.2653 21.0288 11.3232 20.8135 11.6104L15.2627 19.0098L11.793 15.54C11.5391 15.2864 11.1268 15.2863 10.873 15.54C10.6194 15.7938 10.6194 16.2062 10.873 16.46L14.873 20.46C15.0062 20.5931 15.1911 20.6616 15.3789 20.6484C15.5668 20.6351 15.7395 20.5403 15.8525 20.3896L21.8525 12.3896C22.0679 12.1025 22.0098 11.6959 21.7227 11.4805Z"
      fill={STATUS_COLORS.completed}
    />
  </svg>
))
RejectedIcon.displayName = 'RejectedIcon'

const RunningIcon = memo(() => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0003 6.19922C21.4125 6.19939 25.8001 10.5877 25.8001 16C25.7999 21.4121 21.4124 25.7996 16.0003 25.7998C10.588 25.7998 6.1997 21.4122 6.19952 16C6.19952 10.5876 10.5879 6.19922 16.0003 6.19922ZM16.0003 27.5332C22.3697 27.533 27.5333 22.3694 27.5335 16C27.5335 9.63042 22.3698 4.46697 16.0003 4.4668C9.63062 4.4668 4.4671 9.63032 4.4671 16C4.46728 22.3695 9.63073 27.5332 16.0003 27.5332ZM24 15.9997C24 20.418 20.4183 23.9997 16 23.9997C9.59998 23.9997 7.99998 18.6663 7.99998 15.9997H16V7.99967C20.4183 7.99967 24 11.5814 24 15.9997Z"
      fill={STATUS_COLORS.running}
    />
  </svg>
))
RunningIcon.displayName = 'RunningIcon'

export const FutureIcon = memo(() => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.0459 26.6152L17.1084 27.2627C16.7436 27.2982 16.3737 27.3164 16 27.3164C15.6261 27.3164 15.2555 27.2982 14.8906 27.2627L14.9541 26.6152L15.0166 25.9688C15.3397 26.0002 15.6683 26.0166 16 26.0166C16.3316 26.0166 16.6595 26.0002 16.9824 25.9688L17.0459 26.6152ZM11.2773 24.8359C11.8507 25.143 12.4578 25.3961 13.0908 25.5879L12.7139 26.832C11.998 26.6151 11.312 26.3285 10.6641 25.9814L10.9707 25.4092L11.2773 24.8359ZM21.0283 25.4092L21.3359 25.9814C20.6879 26.3286 20.0012 26.6151 19.2852 26.832L18.9082 25.5879C19.5412 25.3961 20.1483 25.143 20.7217 24.8359L21.0283 25.4092ZM8.25586 22.3535C8.6724 22.8605 9.13855 23.3266 9.64551 23.7432L9.23242 24.2451L8.82031 24.748C8.24806 24.2778 7.72216 23.7519 7.25195 23.1797L8.25586 22.3535ZM24.2451 22.7666L24.748 23.1797C24.2777 23.7522 23.7522 24.2777 23.1797 24.748L22.7666 24.2451L22.3535 23.7432C22.8606 23.3265 23.3265 22.8606 23.7432 22.3535L24.2451 22.7666ZM6.41211 18.9082C6.60389 19.5412 6.85701 20.1483 7.16406 20.7217L6.59082 21.0283L6.01758 21.3359C5.67054 20.6879 5.38487 20.0011 5.16797 19.2852L6.41211 18.9082ZM26.832 19.2852C26.6151 20.0012 26.3286 20.6879 25.9814 21.3359L25.4092 21.0283L24.8359 20.7217C25.143 20.1483 25.3961 19.5412 25.5879 18.9082L26.832 19.2852ZM5.38379 14.9541L6.03027 15.0166C5.99883 15.3397 5.98341 15.6683 5.9834 16C5.98341 16.3315 5.99887 16.6595 6.03027 16.9824L5.38379 17.0459L4.73633 17.1084C4.70085 16.7437 4.68263 16.3737 4.68262 16C4.68263 15.6261 4.70082 15.2555 4.73633 14.8906L5.38379 14.9541ZM27.2627 14.8906C27.2982 15.2555 27.3164 15.6261 27.3164 16C27.3164 16.3737 27.2982 16.7436 27.2627 17.1084L26.6152 17.0459L25.9688 16.9824C26.0002 16.6595 26.0166 16.3316 26.0166 16C26.0166 15.6683 26.0002 15.3397 25.9688 15.0166L26.6152 14.9541L27.2627 14.8906ZM7.16406 11.2773C6.85695 11.8507 6.60392 12.4578 6.41211 13.0908L5.16797 12.7139C5.38487 11.998 5.67056 11.312 6.01758 10.6641L7.16406 11.2773ZM25.9814 10.6641C26.3285 11.312 26.6151 11.998 26.832 12.7139L25.5879 13.0908C25.3961 12.4578 25.143 11.8507 24.8359 11.2773L25.4092 10.9707L25.9814 10.6641ZM9.23242 7.75391L9.64551 8.25586C9.13844 8.67248 8.67248 9.13844 8.25586 9.64551L7.75391 9.23242L7.25195 8.82031C7.72232 8.24783 8.24783 7.72232 8.82031 7.25195L9.23242 7.75391ZM23.1797 7.25195C23.7519 7.72216 24.2778 8.24806 24.748 8.82031L24.2451 9.23242L23.7432 9.64551C23.3266 9.13855 22.8605 8.6724 22.3535 8.25586L23.1797 7.25195ZM13.0908 6.41211C12.4578 6.60392 11.8507 6.85695 11.2773 7.16406L10.6641 6.01758C11.312 5.67056 11.998 5.38487 12.7139 5.16797L13.0908 6.41211ZM19.2852 5.16797C20.0011 5.38487 20.6879 5.67054 21.3359 6.01758L21.0283 6.59082L20.7217 7.16406C20.1483 6.85701 19.5412 6.60389 18.9082 6.41211L19.2852 5.16797ZM16 4.68262C16.3737 4.68263 16.7437 4.70085 17.1084 4.73633L17.0459 5.38379L16.9824 6.03027C16.6595 5.99887 16.3315 5.98341 16 5.9834C15.6683 5.98341 15.3397 5.99883 15.0166 6.03027L14.9541 5.38379L14.8906 4.73633C15.2555 4.70082 15.6261 4.68263 16 4.68262Z"
      fill={STATUS_COLORS.future}
    />
  </svg>
))
FutureIcon.displayName = 'FutureIcon'

export const getStatusIcon = (status: ItemStatus): JSX.Element => {
  switch (status) {
    case 'completed':
      return <CompletedIcon />
    case 'running':
    case 'changesrequested':
    case 'overdue':
      return <RunningIcon />
    case 'future':
      return <FutureIcon />
    case 'rejected':
      return <RejectedIcon />
  }
}

export const getStatusColor = (status: ItemStatus): string => {
  switch (status) {
    case 'completed':
      return STATUS_COLORS.completed
    case 'rejected':
      return STATUS_COLORS.rejected
    case 'overdue':
      return STATUS_COLORS.overdue
    case 'running':
    case 'changesrequested':
    case 'future':
      return STATUS_COLORS.default
  }
}

export const getStatusLabel = (status: ItemStatus): string => {
  switch (status) {
    case 'completed':
      return i18n.t('approvals_v2.timeline.status.completed')
    case 'running':
      return i18n.t('approvals_v2.timeline.status.in_progress')
    case 'future':
      return i18n.t('approvals_v2.timeline.status.not_started')
    case 'rejected':
      return i18n.t('approvals_v2.timeline.status.rejected')
    case 'changesrequested':
      return i18n.t('approvals_v2.timeline.status.changes_requested')
    case 'overdue':
      return i18n.t('approvals_v2.timeline.status.overdue')
  }
}

export const getStatusType = (status: ItemStatus): 'positive' | 'warning' | 'critical' | 'info' => {
  switch (status) {
    case 'completed':
      return 'positive'
    case 'running':
    case 'changesrequested':
      return 'warning'
    case 'future':
      return 'info'
    case 'rejected':
      return 'critical'
    case 'overdue':
      return 'warning'
  }
}

export const getContentIcon = (
  type: string,
  actionGroup: string | null | undefined
): JSX.Element => {
  if (type === 'start') {
    return (
      <Box className={styles.pinkIcon}>
        <F0AvatarIcon icon={Sparkles} size="sm" />
      </Box>
    )
  }

  if (actionGroup === 'approvals') {
    return (
      <Box className={styles.purpleIcon}>
        <F0AvatarIcon icon={ThumbsUp} size="sm" />
      </Box>
    )
  }

  if (actionGroup === 'task') {
    return (
      <Box className={styles.blueIcon}>
        <F0AvatarIcon icon={CheckCircle} size="sm" />
      </Box>
    )
  }

  if (actionGroup == null) {
    return <F0AvatarIcon icon={ArrowCycle} size="sm" />
  }

  throw new Error(`Invalid actionGroup value: ${actionGroup}`)
}

interface TimelineItemWrapperProps {
  statusIcon: JSX.Element
  contentIcon: JSX.Element
  hasConnectingLine: boolean
  statusColor: string
  children: React.ReactNode
  alert?: React.ReactNode
}

const TimelineItemWrapper = ({
  statusIcon,
  contentIcon,
  hasConnectingLine,
  statusColor,
  children,
  alert,
}: TimelineItemWrapperProps) => {
  return (
    <Box
      flexDirection="row"
      gap="s16"
      style={{ position: 'relative', paddingBottom: hasConnectingLine ? 's16' : undefined }}
    >
      {/* Status Indicator */}
      <Box alignItems="center" flexNoShrink style={{ position: 'relative' }}>
        {statusIcon}
        {/* Connecting line that extends from bottom of icon to bottom of container */}
        {hasConnectingLine && (
          <Box
            style={{
              position: 'absolute',
              left: CONNECTING_LINE_POSITION.left,
              top: CONNECTING_LINE_POSITION.top,
              bottom: CONNECTING_LINE_POSITION.bottom,
              width: CONNECTING_LINE_POSITION.width,
              backgroundColor: statusColor,
            }}
          />
        )}
      </Box>

      {/* Content */}
      <Box
        flexGrow
        paddingX="s16"
        paddingY="s16"
        borderRadius={{ all: 'abs012' }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        flexDirection="row"
        gap="s12"
      >
        <Box flexDirection="column" flexGrow gap="s24">
          <Box flexDirection="row" gap="s8">
            {contentIcon}
            <Box flexGrow gap="s8" justifyContent="spaceBetween">
              {children}
            </Box>
          </Box>
          {alert}
        </Box>
      </Box>
    </Box>
  )
}

export default TimelineItemWrapper
